// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2xwNz","dragIcon":"SortableItem_dragIcon__99KhV","disabled":"SortableItem_disabled__1lYnK"};